'use client';

import clsx from 'clsx';
import { useParams } from 'next/navigation';

import { PlayerDetailsProfileHeader } from '@/components/molecules/PlayerDetailsProfileHeader';
import { PlayerDetailsProfileImage } from '@/components/molecules/PlayerDetailsProfileImage';
import { PlayerDetailsProfileStats } from '@/components/molecules/PlayerDetailsProfileStats';
import { PlayerDetailsTeammatesList } from '@/components/molecules/PlayerDetailsTeammatesList';
import { PlayerDetailsHeroSectionSkeleton } from '@/components/molecules/skeletons/PlayerDetailsHeroSectionSkeleton';
import { usePlayerBannerQuery } from '@/hooks/player-details/player-banner';
import { getPlayerImageUrl } from '@/utils/utils';

export const PlayerDetailsHeroSection = () => {
	const params = useParams<{
		teamLeagueId: string;
		playerId: string;
	}>();

	const { data: player, isLoading: isLoadingPlayer } = usePlayerBannerQuery(params.teamLeagueId, params.playerId);

	if (isLoadingPlayer) {
		return <PlayerDetailsHeroSectionSkeleton />;
	}

	if (player?.statusCode !== 200 || !player.data) {
		return null;
	}

	const isFreeAgent = player.data.teams.length === 0;
	const isHeaderImageAvailable = !!player.data?.player?.photo?.headerImage?.url;
	const imageUrl = getPlayerImageUrl(player.data.player?.photo);

	return (
		<div className={`bg-white w-full h-full mt-7 md:h-[420px]`}>
			<div
				className={clsx('playerHeroSectionStyle flex flex-col md:flex-row items-center', {
					'justify-between lg:gap-4': !isFreeAgent,
					'md:gap-20 lg:gap-60': isFreeAgent
				})}
			>
				<div className="flex flex-col gap-6">
					<PlayerDetailsProfileHeader player={player.data.player} isFreeAgent={isFreeAgent} />

					<PlayerDetailsProfileStats player={player.data.player} className="hidden md:flex" />
				</div>
				<PlayerDetailsProfileImage
					name={[player.data.player.firstName, player.data.player.lastName].filter(Boolean).join(' ')}
					url={imageUrl}
					isHeaderImageAvailable={isHeaderImageAvailable}
				/>

				<PlayerDetailsProfileStats player={player.data.player} className="flex md:hidden" />

				<PlayerDetailsTeammatesList isFreeAgent={isFreeAgent} teams={player.data.teams} />
			</div>
		</div>
	);
};
